import BadgeForTable from "components/shared-components/BadgeForTable";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
} from "constants/RemoteDataTableContanst";
import { convertDateTime, formatDateTime } from "helpers/utils";
import {
  useChangeCollectorType,
  useDeleteCollectorScheduleChanges,
  useListChangeScheduleByCollector,
} from "hooks/allocate-collector/useAllocateCollector";
import { importAuthStatus } from "pages/ImportManagement/utils";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { customFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import CreateScheduleChangeCollector from "./CreateScheduleChangeCollector";
import { MODE_DETAIL } from "./contants";

const getInitChangeScheduleCollectorParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-checker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
    run: false,
  };
};

const ScheduleCollector = props => {
  const { isOpenModal, toggleModal, dataDetail } = props;
  const { t } = useTranslation(["allocateCollector"]);

  /* ================================== START INIT STATE ==================================== */

  const [columnsTable, setColumnsTable] = useState([]);
  const [changeScheduleCollectorParams, setChangeScheduleCollectorParams] =
    useState(getInitChangeScheduleCollectorParams);
  const [
    isOpenCreateScheduleChangeCollector,
    setIsOpenCreateScheduleChangeCollector,
  ] = useState(false);
  const [
    dataDetailScheduleChangeCollector,
    setDataDetailScheduleChangeCollector,
  ] = useState(null);

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  const {
    refetch: fetchListChangeScheduleByCollector,
    data: listChangeScheduleByCollector,
  } = useListChangeScheduleByCollector({
    params: changeScheduleCollectorParams,
  });

  useEffect(() => {
    initColumn();
  }, []);

  useEffect(() => {
    initColumn();
  }, [listChangeScheduleByCollector]);

  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);

  const onDelteSuccess = () => {
    toggleConfirmDeleteModal();
    fetchListChangeScheduleByCollector();
  };
  const { isLoading: isLoadingDelete, mutate: mutateDelete } =
    useDeleteCollectorScheduleChanges(onDelteSuccess);

  useEffect(() => {
    setChangeScheduleCollectorParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      run: true,
      expand: "runner_name,runner_name_current,timeSlot,maker,object_name",
    }));
  }, [isOpenModal]);

  useEffect(() => {
    if (changeScheduleCollectorParams?.run) {
      fetchListChangeScheduleByCollector();
    }
  }, [changeScheduleCollectorParams]);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setChangeScheduleCollectorParams(prev => ({
      ...prev,
      sort: sortField
        ? sortOrder + sortField
        : changeScheduleCollectorParams.sort,
      columnFilter: columnFilter,
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const initColumn = () => {
    setColumnsTable(initColumns);
  };

  const onSearchAllHandle = value => {
    setChangeScheduleCollectorParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const toggleCreateScheduleChangeCollector = () => {
    if (isOpenCreateScheduleChangeCollector) {
      setDataDetailScheduleChangeCollector(null);
    }
    setIsOpenCreateScheduleChangeCollector(
      !isOpenCreateScheduleChangeCollector
    );
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "auth_status":
        options = importAuthStatus;
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {t(`table.${name}.${prefix}.${item.key}`)}
          </BadgeForTable>
        )
    );
  };

  const [typeList, setTypeList] = useState([]);
  const [filterType, setFilterType] = useState(null);

  useEffect(() => {
    initColumn();
  }, [typeList]);

  const onFetchTypeSuccess = async data => {
    setTypeList(data);
  };

  const {
    refetch: fetchListChangeCollectorType,
    data: listChangeCollectorType,
  } = useChangeCollectorType(null, onFetchTypeSuccess);

  const initColumns = [
    {
      dataField: "maker_date",
      text: "Ngày tạo",
      sort: false,
      formatter: (cell, row) => {
        if (cell) {
          return convertDateTime(cell, formatDateTime.DD_MM_YYYY_HH_MM_SS, "/");
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={changeScheduleCollectorParams.columnFilter}
        />
      ),
    },
    {
      dataField: "object_type",
      text: "Loại",
      sort: false,
      allowExport: true,
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      formatter: (cell, row) => {
        return row?.object_name;
      },
      filterRenderer: (onFilter, column) => {
        return (
          <div style={{ minWidth: "200px", fontWeight: "normal" }}>
            <Select
              isClearable
              placeholder={t("common:placeholder.select")}
              options={typeList}
              classNamePrefix="select2-selection"
              value={filterType}
              onChange={data => {
                onFilter({ data: data });
                setFilterType(data);
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "runner_name_current",
      text: "Collector hiện tại",
      sort: false,
      allowExport: true,
    },
    {
      dataField: "runner_name",
      text: t("table.collector_name"),
      sort: false,
      allowExport: true,
    },
    {
      dataField: "auth_status",
      text: "Trạng thái",
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => {
        return formatOptionsTable(cell, "auth_status", "collector_schedule");
      },
    },

    {
      dataField: "from_date",
      text: t("form.date"),
      sort: false,
      formatter: (cell, row) => {
        if (cell) {
          return convertDateTime(cell, formatDateTime.DD_MM_YYYY, "/");
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={changeScheduleCollectorParams.columnFilter}
        />
      ),
    },
    {
      dataField: "timeSlot",
      text: "Ca",
      sort: false,
      formatter: (cell, row) => {
        return cell?.map(item => item.name).join(", ");
      },
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      sort: false,
      formatter: (cell, row) => {
        if (row?.maker?.display_name) {
          return row?.maker?.display_name;
        }

        return cell;
      },
    },
    {
      dataField: "note",
      text: t("table.note"),
      sort: false,
      allowExport: true,
    },
  ];

  const listRowAction = [
    {
      // actionAccess: actionAccess.UPDATE_JOB_TITLE,
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: "Cập nhật",
      // conditionVisible: {
      //   auth_status: ["M"],
      // },
      onClick: row => {
        toggleCreateScheduleChangeCollector();
        setDataDetailScheduleChangeCollector({
          mode: MODE_DETAIL.UPDATE,
          ...row,
        });
      },
    },
    {
      icon: <i className="fas fa-trash fa-lg text-danger" />,
      // conditionVisible: {
      //   auth_status: ["M"],
      // },
      text: "Xóa",
      onClick: row => {
        toggleConfirmDeleteModal();
        setDataDetailScheduleChangeCollector({
          ...row,
        });
      },
    },
  ];

  return (
    <React.Fragment>
      <Modal
        style={{ maxWidth: "95%" }}
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        {/* Delete Modal */}
        <ConfirmModal
          isOpen={modalConfirmDelete}
          titleHeader={"Xác nhận xóa lịch"}
          titleBody={"Hệ thống sẽ thực hiện xóa lịch này ?"}
          isDisableButton={isLoadingDelete}
          onConfirm={note => {
            mutateDelete({
              id: dataDetailScheduleChangeCollector?.id,
            });
          }}
          textBtnConfirm={"Xác nhận"}
          textBtnCancel={"Đóng"}
          toggle={toggleConfirmDeleteModal}
        />
        <CreateScheduleChangeCollector
          dataDetail={dataDetailScheduleChangeCollector}
          refetchList={fetchListChangeScheduleByCollector}
          isOpenModal={isOpenCreateScheduleChangeCollector}
          toggleModal={toggleCreateScheduleChangeCollector}
        />
        <ModalHeader toggle={toggleModal}>
          {t("title.change_schedule_collector_list")} (
          {listChangeScheduleByCollector?.totalCount || 0})
        </ModalHeader>
        <ModalBody>
          {columnsTable.length > 0 && (
            <RemoteDataTable
              keyField="id"
              data={listChangeScheduleByCollector?.items || []}
              columns={columnsTable}
              page={changeScheduleCollectorParams.page}
              sizePerPage={changeScheduleCollectorParams.sizePerPage}
              totalSize={listChangeScheduleByCollector?.totalCount || 0}
              onTableChange={handleTableChange}
              onSearchAllHandle={onSearchAllHandle}
              loading={false}
              listRowAction={listRowAction}
            >
              <Button
                onClick={() => {
                  toggleCreateScheduleChangeCollector();
                }}
                color="success"
                className="btn-label me-2"
                type="button"
              >
                <i className="fas fa-plus label-icon" />
                Tạo lịch đổi ca
              </Button>
            </RemoteDataTable>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

ScheduleCollector.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
};

ScheduleCollector.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
};

export default ScheduleCollector;
